/*
  GreenOx – Custom-Elemente

  Die frühere Wunschlieferdatum-Logik stand hier (Datepicker-Dialog, DOM-Reparatur per
  Polling, localStorage-Backup). Sie ist ersetzt durch assets/gox-lieferdatum.js — siehe
  snippets/gox-lieferdatum.liquid.
*/

// Rest des Codes...
class secondarynav extends HTMLElement {
  connectedCallback() {
    this.parent = this.closest('x-header');
    this.primaryNav = this.parent.querySelector("nav[extends='secondary-nav']");
    this.primaryNavItems = this.primaryNav.querySelectorAll('li');

    this.secondaryNavItems = this.querySelectorAll('[secondary-nav-target]');
    this.activeNav = localStorage.getItem('greenox-header-active');

    if (this.activeNav ?? false) {
      this.secondaryNavItems.forEach((navigation) => {
        if (navigation.getAttribute('secondary-nav-target') === this.activeNav) {
          navigation.classList.remove('hidden');
        } else {
          navigation.classList.add('hidden');
        }
      });
    }

    this.primaryNavItems.forEach((item) => {
      item.addEventListener('mouseover', (event) => this.handleHover(event));
      item.addEventListener('click', (event) => this.handleClick(event));
    });
  }

  handleClick = (event) => {
    let _this = event.currentTarget;
    this.secondaryNavItems.forEach((navItem) => {
      if (navItem.getAttribute('secondary-nav-target') === _this.getAttribute('secondary-nav-target')) {
        navItem.classList.remove('hidden');
        localStorage.setItem('greenox-header-active', _this.getAttribute('secondary-nav-target'));
      } else {
        navItem.classList.add('hidden');
      }
    });
  };

  handleHover = (event) => {
    let _this = event.currentTarget;
    this.secondaryNavItems.forEach((navItem) => {
      if (navItem.getAttribute('secondary-nav-target') === _this.getAttribute('secondary-nav-target')) {
        navItem.classList.remove('hidden');
      } else {
        navItem.classList.add('hidden');
      }
    });
  };
}

/*Init Custom Elements*/
window.customElements.define('secondary-nav', secondarynav);